import { render } from "./NewsDetail.vue?vue&type=template&id=41e4938e&ts=true"
import script from "./NewsDetail.vue?vue&type=script&lang=ts"
export * from "./NewsDetail.vue?vue&type=script&lang=ts"

import "./NewsDetail.vue?vue&type=style&index=0&id=41e4938e&lang=scss"

import exportComponent from "/builds/filmin/press-center/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__